// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__37nYd","emails":"CreateEditClinics_emails__3QR_m","emailTagLabel":"CreateEditClinics_emailTagLabel__2xA0L"};